<div class="container" align="center">
  <div class="row">
    <img id="amcHaken" class="img-responsive center-block" src="{{stickImage}}"/>
  </div>
  <div class="row">
    <div class="col-md-6 col-sm-6 col-md-offset-3 col-sm-offset-3">
      <p style="text-align: center;">{{getFieldLabel('nl_success_unsub')}}</p>
    </div>
  </div>
</div>
